.infoWindowContent {
  display: block;
  padding: 10px 14px;
  color: #4e4741;
  font-family: var(--font-detail);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.2px;
  white-space: nowrap;
}
